import { render, staticRenderFns } from "./ProductoNew.vue?vue&type=template&id=a94b22a4&scoped=true&"
import script from "./ProductoNew.vue?vue&type=script&lang=js&"
export * from "./ProductoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b22a4",
  null
  
)

export default component.exports